import axios from "axios";

const i18n = {
  setLocale: (locale: string) =>
    axios.put("/api/v1/account/active", { locale }),
};

export default i18n;
